module.exports = __webpack_public_path__ + "media/images/anagrama_tirant_blanco-577757a9.png";